import { reducerWithInitialState } from 'typescript-fsa-reducers';
import * as actions from './actions';

type DetailState = Readonly<{
  [key: string]: Readonly<{
    isFetching: boolean;
    error: any | null;
  }>;
}>;

const DETAIL_INITIAL_STATE: DetailState = {};

export const layoutsByIdReducer = reducerWithInitialState(DETAIL_INITIAL_STATE)
  .case(
    actions.loadDetail.async.started,
    (state, params: any): DetailState => ({
      ...state,
      [params.layoutId]: {
        isFetching: true,
        error: '',
      },
    }),
  )
  .case(
    actions.loadDetail.async.done,
    (state, { params }): DetailState => ({
      ...state,
      [params.layoutId]: {
        isFetching: false,
        error: null,
      },
    }),
  )
  .case(
    actions.loadDetail.async.failed,
    (state, { error, params }): DetailState => ({
      ...state,
      [params.layoutId]: {
        isFetching: false,
        error,
      },
    }),
  );
